var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.37802 1.50012H45.6315C48.3272 1.4811 50.5243 3.68963 50.5243 6.37815V10.6469M50.5243 41.6813V53.5733",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.134 61.5H51.7437C54.4378 61.5 56.6217 59.3161 56.6217 56.622V54.1831H21.0121V56.622C21.0121 59.3161 18.8282 61.5 16.134 61.5ZM16.134 61.5C13.4399 61.5 11.256 59.3161 11.256 56.622V6.37803C11.256 3.68402 9.07214 1.5 6.37801 1.5C3.68389 1.5 1.5 3.68402 1.5 6.37803V8.81704H10.6463",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5243 10.647C52.1772 10.647 53.5675 11.7705 53.9734 13.2956C55.3389 12.5044 57.1165 12.6929 58.2853 13.8617C59.454 15.0305 59.6426 16.8081 58.8514 18.1736C60.3763 18.5797 61.5 19.9699 61.5 21.6227C61.5 23.2755 60.3765 24.6659 58.8514 25.0718C59.6426 26.4373 59.454 28.2149 58.2853 29.3837C57.1165 30.5525 55.3389 30.741 53.9734 29.9498C53.5673 31.4748 52.1771 32.5984 50.5243 32.5984C48.8714 32.5984 47.4811 31.4748 47.0752 29.9498C45.7097 30.741 43.9321 30.5525 42.7634 29.3837C41.5946 28.2149 41.406 26.4373 42.1973 25.0718C40.6723 24.6659 39.5487 23.2755 39.5487 21.6227C39.5487 19.9699 40.6724 18.5795 42.1973 18.1736C41.406 16.8081 41.5946 15.0305 42.7634 13.8617C43.9321 12.6929 45.7097 12.5044 47.0752 13.2956C47.4811 11.7705 48.8714 10.647 50.5243 10.647Z",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2256 30.6729V44.4276L50.5243 41.0716L44.823 44.4276V30.6729",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1505 25.4738C53.2779 25.1285 54.7226 23.124 54.3774 20.9965C54.0321 18.8691 52.0276 17.4243 49.9001 17.7696C47.7727 18.1149 46.3279 20.1194 46.6732 22.2469C47.0185 24.3743 49.023 25.8191 51.1505 25.4738Z",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7439 8.81714H37.1419",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7439 14.4617H30.8902",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7439 25.751H30.8902",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7439 31.3955H37.1419",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7439 37.04H37.1419",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7439 42.6848H30.8902",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7439 48.3293H37.1419",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificate);
export default __webpack_public_path__ + "static/media/certificate.ee29c1da12d6e15d2c5a99015819bd35.svg";
export { ForwardRef as ReactComponent };